.language {
  flex-grow: 2;
}

.list {
  height: 100%;
  overflow-y: auto;
}

.filterButton {
  width: 40px;
  padding: 0;

  &Wide {
    width: auto;
    flex: 1 1 auto;
  }
}

.loadingState {
  height: 100%;
}
